<template lang="html">
  <div class="card-cont-recurso col-sm-6 col-lg-4">
    <div class="card-recurso">
      <router-link :to="$t('enlaces.actualidad')+'/'+data.IdNoticia"></router-link>
      <img v-if="!!data.ImagenPrincipal" :src="'data:application/gzip;base64,'+data.ImagenPrincipal"></img>
      <div v-else class="no-image-recurso"></div>
      <div style="height: 11%; width: 100%;">
        <label class="lbl-tipo-recurso">{{$t(data.Tipo).toUpperCase()}}</label>
        <label class="lbl-date-recurso">{{new Date(data.FechaPublicacion).toLocaleDateString('en-GB')}}</label>
      </div>
      <label class="lbl-title-recurso">{{data.Titulo}}</label>
      <label class="lbl-body-recurso">{{data.Entradilla}}</label>    
    </div>
  </div>
</template>

<script lang="js">
  export default  {
    name: 'actualidad-el',
    props :['data'],
    methods : {
      parseISOString: function(s){
        var b = s.split(/\D+/);
        return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
      }
    },
    filters: {
    }
  }
</script>

<style scoped lang="scss">

.card-cont-recurso{
    height: 500px;
    padding: 15px !important;
    min-width: 250px;
  }

  .card-recurso{
    height: 100%;
    width: 100%;
    margin: 15px;
    background: #F0ECE8;
    cursor: pointer;

    a{
      position: absolute;
      width: 96%;
      height: 80%;
      top: 20%;
      left: 4%;
    }

    img{
      height: 40%;
      width: 100%;
      object-fit: cover;
    }

    .no-image-recurso{
      height: 40%;
      width: 100%;
      background: #cfcdcb;
    }

    .lbl-tipo-recurso{
      float: left;
      margin-left: 18px;
      margin-top: 13px;
      color: #ff5700;
      cursor: pointer;
    }

    .lbl-date-recurso{
      float: right;
      margin-right: 18px;
      margin-top: 13px;
      cursor: pointer;
    }

    .lbl-title-recurso{
      width: 90%;
      height: 9%;
      font-weight: 600;
      font-size: 24px;
      text-align: left;
      margin: 0 18px;
      display:inline-block;
      white-space: nowrap; 
      overflow: hidden;
      text-overflow: ellipsis; 
      cursor: pointer;
    }

    .lbl-body-recurso{
      width: 90%;
      font-size: 18px;
      text-align: left;
      margin: 0 18px;
      height: 35%;
      display:inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/views/noticias/actualidad-el.vue